/**
 * useAnalytics — EV-54: fires trackPageview on every react-router route change.
 *
 * Usage: mount <AnalyticsTracker /> once, inside <Router>, high in the tree.
 * The component renders null — zero DOM impact.
 *
 * track() / trackPageview() are both no-ops when analytics consent is not
 * granted, so there is no need to wrap <AnalyticsTracker /> in a consent gate.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from './analytics';

export function useAnalytics(): void {
  const location = useLocation();

  useEffect(() => {
    try {
      trackPageview(location.pathname);
    } catch {
      // analytics must never break the app
    }
  }, [location.pathname]);
}

/** Null-render component that calls useAnalytics(). Mount once inside <Router>. */
export function AnalyticsTracker(): null {
  useAnalytics();
  return null;
}
